import React, { useEffect, useState } from "react";
import PageHeading from "../../components/PageHeading";
import { BackButton } from "../../components/btn/Buttons";
import Button from "../../components/btn/Button";
import Input from "../../components/inputs/Input";
import "./DayEnd.css";
import { useSelector } from "react-redux";
import moment from "moment";
import store from "../../redux/store";
import { get_vehicle_tracking } from "./DayendDaySlice";
import PageLoading from "../../components/PageLoading";
import { toast } from "react-toastify";
import Table from "../../components/table/Table";
import { Pagination2 } from "../../components/pagination/pagination";
import {
  base_url,
  DeleteIcon,
  downloadExcelWithMerge,
  exportPDFWithMerge,
} from "../../utils/utils";
import SmallModal from "../../components/modal/SmallModal";

const VehicleTracking = () => {
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [entries, setEntries] = useState("5");
  const [serchInput, setSerchInput] = useState("");
  const { user_id } = useSelector((state) => state.other);
  const { firm_name } = useSelector((state) => state.profile);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const {
    vehicle_tracking_list,
    vehicle_tracking_loading,
    vehicle_tracking_count,
  } = useSelector((state) => state.day_end);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    store.dispatch(
      get_vehicle_tracking({ date: date, page: pageNo, limit: entries })
    );
  };

  const handleGenerate = () => {
    if (!date) {
      toast.error("Please select a date");
      return;
    }
    loadData();
  };

  const get_list = async (exportType = "") => {
    try {
      setLoading(true);
      const body = new FormData();
      body.append("action", "list");
      body.append("agencyid", user_id);
      body.append("date", date);
      body.append("page", 1);
      body.append("limit", vehicle_tracking_count);

      const response = await fetch(base_url + "reports/vehicle_tracking.php", {
        method: "POST",
        body: body,
      });
      const result = await response.json();

      if (result.success) {
        const processedExportData = processDataForExport(result?.data);

        if (exportType === "excel") {
          export_excel(processedExportData);
        } else if (exportType === "pdf") {
          export_pdf(processedExportData);
        }
      } else {
        toast.error("Failed to fetch data for export");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error exporting data");
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async () => {
    try {
      setLoading(true);
      const body = new FormData();
      body.append("action", "delete");
      body.append("agencyid", user_id);
      body.append("id", id);
      body.append("deleted_by", user_id);

      const response = await fetch(base_url + "reports/vehicle_tracking.php", {
        method: "POST",
        body: body,
      });
      const result = await response.json();

      if (result.success) {
        setOpen(false);
        loadData();
        toast.success(
          result.message || "Vehicle tracking record deleted successfully"
        );
      } else {
        toast.error(
          result.message || "Failed to delete vehicle tracking record"
        );
      }
    } catch (error) {
      console.log(error);
      toast.error("Error exporting data");
    } finally {
      setLoading(false);
    }
  };

  // Process data with grouping information
  const processData = () => {
    const processed = [];

    vehicle_tracking_list?.forEach((vehicle) => {
      const details = vehicle.details || [];

      // Group details by GODOWN_NAME and MOVEMENT_TYPE
      const groups = [];
      let currentGroup = null;

      details.forEach((detail) => {
        const key = `${detail.GODOWN_NAME}_${detail.MOVEMENT_TYPE}`;

        if (!currentGroup || currentGroup.key !== key) {
          currentGroup = {
            key,
            godown: detail.GODOWN_NAME,
            movementType: detail.MOVEMENT_TYPE,
            items: [],
            startIndex:
              processed.length +
              groups.reduce((sum, g) => sum + g.items.length, 0),
          };
          groups.push(currentGroup);
        }

        currentGroup.items.push(detail);
      });

      // Flatten groups into rows
      groups.forEach((group, groupIndex) => {
        group.items.forEach((detail, itemIndex) => {
          processed.push({
            ...vehicle,
            ...detail,
            isFirstRow: groupIndex === 0 && itemIndex === 0,
            isFirstInGroup: itemIndex === 0,
            vehicleRowSpan: details.length,
            groupRowSpan: group.items.length,
            godownName: group.godown,
            movementType: group.movementType,
          });
        });
      });
    });

    return processed;
  };

  // Process data for export with merge information
  const processDataForExport = (data) => {
    const rows = [];
    const merges = [];
    let currentRow = 0;

    data?.forEach((vehicle) => {
      const details = vehicle.details || [];
      const vehicleStartRow = currentRow;

      // Group details by GODOWN_NAME and MOVEMENT_TYPE
      const groups = [];
      let currentGroup = null;

      details.forEach((detail) => {
        const key = `${detail.GODOWN_NAME}_${detail.MOVEMENT_TYPE}`;

        if (!currentGroup || currentGroup.key !== key) {
          currentGroup = {
            key,
            godown: detail.GODOWN_NAME,
            movementType: detail.MOVEMENT_TYPE,
            items: [],
          };
          groups.push(currentGroup);
        }

        currentGroup.items.push(detail);
      });

      // Add vehicle info merges (columns 0-4)
      if (details.length > 1) {
        for (let col = 0; col < 5; col++) {
          merges.push({
            s: { r: currentRow, c: col },
            e: { r: currentRow + details.length - 1, c: col },
          });
        }
      }

      // Flatten groups into rows with merge info
      groups.forEach((group) => {
        const groupStartRow = currentRow;

        group.items.forEach((detail, itemIndex) => {
          rows.push([
            itemIndex === 0 ? vehicle.EMPLOYEE_NAME : "",
            itemIndex === 0 ? vehicle.VEHICLE_NO : "",
            itemIndex === 0 ? vehicle.STAFF_NAME : "",
            itemIndex === 0 ? vehicle.REF_NO : "",
            itemIndex === 0
              ? moment(vehicle.REF_DATE).format("DD/MM/YYYY hh:mm A")
              : "",
            itemIndex === 0
              ? moment(vehicle.CREATED_DATE).format("DD/MM/YYYY hh:mm A")
              : "",
            itemIndex === 0 ? group.godown : "",
            itemIndex === 0 ? group.movementType : "",
            detail.PRODUCT_NAME,
            detail.FULLS_IN || 0,
            detail.EMPTYS_IN || 0,
            detail.FULLS_OUT || 0,
            detail.EMPTYS_OUT || 0,
          ]);

          currentRow++;
        });

        // Add godown and movement type merges (columns 5-6)
        if (group.items.length > 1) {
          for (let col = 5; col < 7; col++) {
            merges.push({
              s: { r: groupStartRow, c: col },
              e: { r: currentRow - 1, c: col },
            });
          }
        }
      });
    });

    return { rows, merges };
  };

  const table_header = [
    "GODOWN MANAGER NAME",
    "VEHICLE NO",
    "DRIVER NAME",
    "REF NO",
    "INVOICE DATE",
    "CREATED DATE",
    "GODOWN NAME",
    "MOVEMENT TYPE",
    "PRODUCT NAME",
    "FULLS IN",
    "EMPTYS IN",
    "FULLS OUT",
    "EMPTYS OUT",
    "Actions",
  ];

  const processedData = processData();

  const export_pdf = (processedExportData) => {
    const { rows } = processedExportData;

    exportPDFWithMerge({
      table_data: rows,
      table_headers: table_header,
      tableName: `Vehicle Tracking Report - ${moment(date).format(
        "DD/MM/YYYY"
      )}`,
      fileName: `${firm_name}_VehicleTracking_${moment(date).format(
        "DDMMYYYY"
      )}`,
      processedData: processedData, // Pass processed data for rowspan info
    });
  };

  const export_excel = (processedExportData) => {
    const { rows, merges } = processedExportData;

    downloadExcelWithMerge(
      rows,
      table_header,
      `Godown Register Report - ${moment(date).format("DD/MM/YYYY")}`,
      merges
    );
  };

  return (
    <div className="container">
      <PageHeading
        title={"Godown Register"}
        right={
          <>
            <BackButton />
          </>
        }
      />

      <div className="transactionMain">
        <div style={{ width: "180px" }}>
          <Input
            label={"Select Date"}
            type={"date"}
            value={date}
            onChange={(e) => {
              if (e.target.value.length <= 10) {
                setDate(e.target.value);
              }
            }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <Button
            disable={vehicle_tracking_loading || loading}
            title={"GENERATE"}
            onClick={handleGenerate}
          />
        </div>
      </div>

      <Pagination2
        count={0}
        download={true}
        PDFDown={() => get_list("pdf")}
        excelDown={() => get_list("excel")}
        top={true}
        totalCount={vehicle_tracking_count}
        SerchInput={serchInput}
        setSearchInput={setSerchInput}
        pageNo={pageNo}
        setPageNo={setPageNo}
        entries={entries}
        setEntries={setEntries}
      />

      {vehicle_tracking_loading || loading ? (
        <PageLoading />
      ) : (
        <div style={{ marginTop: "20px" }}>
          <Table
            headData={table_header}
            body={processedData?.map((row, index) => (
              <tr key={index}>
                {row.isFirstRow && (
                  <>
                    <td rowSpan={row.vehicleRowSpan} className="merged-cell">
                      {row.EMPLOYEE_NAME}
                    </td>
                    <td rowSpan={row.vehicleRowSpan} className="merged-cell">
                      {row.VEHICLE_NO}
                    </td>
                    <td rowSpan={row.vehicleRowSpan} className="merged-cell">
                      {row.STAFF_NAME}
                    </td>
                    <td rowSpan={row.vehicleRowSpan} className="merged-cell">
                      {row.REF_NO}
                    </td>
                    <td rowSpan={row.vehicleRowSpan} className="merged-cell">
                      {moment(row.REF_DATE).format("DD/MM/YYYY hh:mm A")}
                    </td>
                    <td rowSpan={row.vehicleRowSpan} className="merged-cell">
                      {moment(row.CREATED_DATE).format("DD/MM/YYYY hh:mm A")}
                    </td>
                  </>
                )}

                {row.isFirstInGroup && (
                  <>
                    <td
                      rowSpan={row.groupRowSpan}
                      className="merged-cell-light"
                    >
                      {row.godownName}
                    </td>
                    <td
                      rowSpan={row.groupRowSpan}
                      className="merged-cell-light"
                    >
                      <span
                        style={{
                          padding: "4px 12px",
                          borderRadius: "6px",
                          backgroundColor:
                            row.movementType === "IN" ? "#d4edda" : "#f8d7da",
                          color:
                            row.movementType === "IN" ? "#155724" : "#721c24",
                          fontWeight: "600",
                          fontSize: "12px",
                          display: "inline-block",
                        }}
                      >
                        {row.movementType}
                      </span>
                    </td>
                  </>
                )}

                <td>{row.PRODUCT_NAME}</td>
                <td>{row.FULLS_IN || 0}</td>
                <td>{row.EMPTYS_IN || 0}</td>
                <td>{row.FULLS_OUT || 0}</td>
                <td>{row.EMPTYS_OUT || 0}</td>
                {row.isFirstInGroup && (
                  <td rowSpan={row.groupRowSpan} className="merged-cell-light">
                    <DeleteIcon
                      onClick={() => {
                        setOpen(true);
                        setId(row.ID);
                      }}
                    />
                  </td>
                )}
              </tr>
            ))}
          />

          {processedData?.length === 0 && (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                color: "#888",
                fontSize: "16px",
              }}
            >
              No tracking data available for the selected date
            </div>
          )}
        </div>
      )}

      <Pagination2
        count={0}
        bottom={true}
        totalCount={vehicle_tracking_count}
        SerchInput={serchInput}
        setSearchInput={setSerchInput}
        pageNo={pageNo}
        setPageNo={setPageNo}
        entries={entries}
        setEntries={setEntries}
      />
      {open && (
        <SmallModal
          title={"Delete Vehicle Tracking"}
          isOpen={open}
          setIsOpen={setOpen}
          mess={"Are you sure you want to delete this vehicle tracking record?"}
          onClick={() => {
            handleDelete();
          }}
        />
      )}
    </div>
  );
};

export default VehicleTracking;
// import React, { useEffect, useState } from "react";
// import PageHeading from "../../components/PageHeading";
// import { BackButton } from "../../components/btn/Buttons";
// import Button from "../../components/btn/Button";
// import Input from "../../components/inputs/Input";
// import "./DayEnd.css";
// import { useSelector } from "react-redux";
// import moment from "moment";
// import store from "../../redux/store";
// import { get_vehicle_tracking } from "./DayendDaySlice";
// import PageLoading from "../../components/PageLoading";
// import { toast } from "react-toastify";
// import Table from "../../components/table/Table";
// import { Pagination2 } from "../../components/pagination/pagination";
// import { base_url, downloadExcel, exportPDF } from "../../utils/utils";

// const VehicleTracking = () => {
//   const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
//   const [loading, setLoading] = useState(false);
//   const [pageNo, setPageNo] = useState(1);
//   const [entries, setEntries] = useState("5");
//   const [serchInput, setSerchInput] = useState("");
//   const { user_id } = useSelector((state) => state.other);
//   const { firm_name } = useSelector((state) => state.profile);
//   const {
//     vehicle_tracking_list,
//     vehicle_tracking_loading,
//     vehicle_tracking_count,
//   } = useSelector((state) => state.day_end);

//   useEffect(() => {
//     loadData();
//   }, []);

//   const loadData = () => {
//     store.dispatch(get_vehicle_tracking({ date: date, page: 1, limit: 100 }));
//   };

//   const handleGenerate = () => {
//     if (!date) {
//       toast.error("Please select a date");
//       return;
//     }
//     loadData();
//   };

//   const get_list = async (data1 = "") => {
//     try {
//       setLoading(true);
//       const body = new FormData();
//       body.append("action", "list");
//       body.append("agencyid", user_id);
//       body.append("date", date);

//       body.append("page", 1);
//       body.append("limit", vehicle_tracking_count);

//       const response = await fetch(base_url + "reports/vehicle_tracking.php", {
//         method: "POST",
//         body: body,
//       });
//       const result = await response.json();

//       if (result.success) {
//         if (data1 === "excel") {
//           export_excel(result?.data);
//         } else if (data1 === "pdf") {
//           export_pdf(result?.data);
//         }
//       } else {
//       }
//     } catch (error) {
//       console.log(error);

//       setLoading(false);
//     }
//   };
//   // Process data with grouping information
//   const processData = () => {
//     const processed = [];

//     vehicle_tracking_list?.forEach((vehicle) => {
//       const details = vehicle.details || [];

//       // Group details by GODOWN_NAME and MOVEMENT_TYPE
//       const groups = [];
//       let currentGroup = null;

//       details.forEach((detail, detailIndex) => {
//         const key = `${detail.GODOWN_NAME}_${detail.MOVEMENT_TYPE}`;

//         if (!currentGroup || currentGroup.key !== key) {
//           // Start a new group
//           currentGroup = {
//             key,
//             godown: detail.GODOWN_NAME,
//             movementType: detail.MOVEMENT_TYPE,
//             items: [],
//             startIndex:
//               processed.length +
//               groups.reduce((sum, g) => sum + g.items.length, 0),
//           };
//           groups.push(currentGroup);
//         }

//         currentGroup.items.push(detail);
//       });

//       // Flatten groups into rows
//       groups.forEach((group, groupIndex) => {
//         group.items.forEach((detail, itemIndex) => {
//           processed.push({
//             ...vehicle,
//             ...detail,
//             isFirstRow: groupIndex === 0 && itemIndex === 0,
//             isFirstInGroup: itemIndex === 0,
//             vehicleRowSpan: details.length,
//             groupRowSpan: group.items.length,
//             godownName: group.godown,
//             movementType: group.movementType,
//           });
//         });
//       });
//     });

//     return processed;
//   };
//   const table_header = [
//     "Godown Manager NAME",
//     "VEHICLE NO",
//     "Driver NAME",
//     "REF NO",
//     "CREATED DATE",
//     "GODOWN NAME",
//     "MOVEMENT TYPE",
//     "PRODUCT NAME",
//     "FULLS IN",
//     "EMPTYS IN",
//     "FULLS OUT",
//     "EMPTYS OUT",
//   ];
//   const processedData = processData();

//   const export_pdf = (addData, data) => {
//     const exportData = data?.map((v, i) => [
//       v?.EMPLOYEE_NAME || "NA",
//       v?.VEHICLE_NO || "NA",
//       v?.STAFF_NAME || "NA",
//       v?.REF_NO || "NA",
//       moment(v.CREATED_DATE).format("DD/MM/YYYY hh:mm A") || "NA",
//     ]);
//     console.log("exportData", exportData);

//     exportPDF({
//       table_data: exportData,
//       table_headers: table_header,
//       tableName: `Vehicle Tracking Report - ${moment(date).format(
//         "DD/MM/YYYY"
//       )}`,
//       fileName: firm_name,
//     });
//   };

//   const export_excel = (data) => {
//     const exportData = data?.map((v, i) => [
//       v?.EMPLOYEE_NAME || "NA",
//       v?.VEHICLE_NO || "NA",
//       v?.STAFF_NAME || "NA",
//       v?.REF_NO || "NA",
//       moment(v.CREATED_DATE).format("DD/MM/YYYY hh:mm A") || "NA",
//     ]);
//     console.log("exportData===>", exportData);
//     downloadExcel(
//       exportData,
//       table_header,
//       `Vehicle Tracking Report - ${moment(date).format("DD/MM/YYYY")}`
//     );
//   };
//   return (
//     <div className="container">
//       <PageHeading
//         title={"Vehicle Tracking"}
//         right={
//           <>
//             <BackButton />
//           </>
//         }
//       />

//       <div className="transactionMain">
//         <div style={{ width: "180px" }}>
//           <Input
//             label={"Select Date"}
//             type={"date"}
//             value={date}
//             onChange={(e) => {
//               if (e.target.value.length <= 10) {
//                 setDate(e.target.value);
//               }
//             }}
//           />
//         </div>

//         <div style={{ display: "flex", alignItems: "flex-end" }}>
//           <Button
//             disable={vehicle_tracking_loading}
//             title={"GENERATE"}
//             onClick={handleGenerate}
//           />
//         </div>
//       </div>

//       <Pagination2
//         count={0}
//         download={true}
//         PDFDown={() => get_list("pdf")}
//         excelDown={() => get_list("excel")}
//         top={true}
//         totalCount={vehicle_tracking_count}
//         SerchInput={serchInput}
//         setSearchInput={setSerchInput}
//         pageNo={pageNo}
//         setPageNo={setPageNo}
//         entries={entries}
//         setEntries={setEntries}
//       />
//       {vehicle_tracking_loading ? (
//         <PageLoading />
//       ) : (
//         <div style={{ marginTop: "20px" }}>
//           <Table
//             headData={table_header}
//             body={processedData?.map((row, index) => (
//               <tr key={index}>
//                 {/* Vehicle Information - Merged for all details */}
//                 {row.isFirstRow && (
//                   <>
//                     <td rowSpan={row.vehicleRowSpan} className="merged-cell">
//                       {row.EMPLOYEE_NAME}
//                     </td>
//                     <td rowSpan={row.vehicleRowSpan} className="merged-cell">
//                       {row.VEHICLE_NO}
//                     </td>
//                     <td rowSpan={row.vehicleRowSpan} className="merged-cell">
//                       {row.STAFF_NAME}
//                     </td>
//                     <td rowSpan={row.vehicleRowSpan} className="merged-cell">
//                       {row.REF_NO}
//                     </td>
//                     <td rowSpan={row.vehicleRowSpan} className="merged-cell">
//                       {moment(row.CREATED_DATE).format("DD/MM/YYYY hh:mm A")}
//                     </td>
//                   </>
//                 )}

//                 {/* Godown and Movement Type - Merged for same godown+movement type */}
//                 {row.isFirstInGroup && (
//                   <>
//                     <td
//                       rowSpan={row.groupRowSpan}
//                       className="merged-cell-light"
//                     >
//                       {row.godownName}
//                     </td>
//                     <td
//                       rowSpan={row.groupRowSpan}
//                       className="merged-cell-light"
//                     >
//                       <span
//                         style={{
//                           padding: "4px 12px",
//                           borderRadius: "6px",
//                           backgroundColor:
//                             row.movementType === "IN" ? "#d4edda" : "#f8d7da",
//                           color:
//                             row.movementType === "IN" ? "#155724" : "#721c24",
//                           fontWeight: "600",
//                           fontSize: "12px",
//                           display: "inline-block",
//                         }}
//                       >
//                         {row.movementType}
//                       </span>
//                     </td>
//                   </>
//                 )}

//                 {/* Product Details - Individual for each row */}
//                 <td>{row.PRODUCT_NAME}</td>
//                 <td>{row.FULLS_IN || 0}</td>
//                 <td>{row.EMPTYS_IN || 0}</td>
//                 <td>{row.FULLS_OUT || 0}</td>
//                 <td>{row.EMPTYS_OUT || 0}</td>
//               </tr>
//             ))}
//           />

//           {processedData?.length === 0 && (
//             <div
//               style={{
//                 textAlign: "center",
//                 padding: "40px",
//                 color: "#888",
//                 fontSize: "16px",
//               }}
//             >
//               No tracking data available for the selected date
//             </div>
//           )}
//         </div>
//       )}
//       <Pagination2
//         count={0}
//         bottom={true}
//         totalCount={vehicle_tracking_count}
//         SerchInput={serchInput}
//         setSearchInput={setSerchInput}
//         pageNo={pageNo}
//         setPageNo={setPageNo}
//         entries={entries}
//         setEntries={setEntries}
//       />
//     </div>
//   );
// };

// export default VehicleTracking;
// // import React, { useEffect, useState } from "react";
// // import PageHeading from "../../components/PageHeading";
// // import { BackButton } from "../../components/btn/Buttons";
// // import Button from "../../components/btn/Button";
// // import Input from "../../components/inputs/Input";
// // import "./DayEnd.css";
// // import { useSelector } from "react-redux";
// // import moment from "moment";
// // import store from "../../redux/store";
// // import { get_vehicle_tracking } from "./DayendDaySlice";
// // import PageLoading from "../../components/PageLoading";
// // import { toast } from "react-toastify";
// // import Table from "../../components/table/Table";

// // const VehicleTracking = () => {
// //   const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
// //   const { vehicle_tracking_list, vehicle_tracking_loading } = useSelector(
// //     (state) => state.day_end
// //   );

// //   useEffect(() => {
// //     loadData();
// //   }, []);

// //   const loadData = () => {
// //     store.dispatch(get_vehicle_tracking({ date: date, page: 1, limit: 100 }));
// //   };

// //   const handleGenerate = () => {
// //     if (!date) {
// //       toast.error("Please select a date");
// //       return;
// //     }
// //     loadData();
// //   };

// //   // Flatten data to show all vehicle trips with their details
// //   const flattenData = () => {
// //     const flattened = [];

// //     vehicle_tracking_list?.forEach((vehicle) => {
// //       vehicle.details?.forEach((detail, index) => {
// //         flattened.push({
// //           ...vehicle,
// //           ...detail,
// //           isFirstRow: index === 0,
// //           detailsCount: vehicle.details?.length || 0,
// //         });
// //       });
// //     });

// //     return flattened;
// //   };

// //   const flatData = flattenData();

// //   return (
// //     <div className="container">
// //       <PageHeading
// //         title={"Vehicle Tracking"}
// //         right={
// //           <>
// //             <BackButton />
// //           </>
// //         }
// //       />

// //       <div className="transactionMain">
// //         <div style={{ width: "180px" }}>
// //           <Input
// //             label={"Select Date"}
// //             type={"date"}
// //             value={date}
// //             onChange={(e) => {
// //               if (e.target.value.length <= 10) {
// //                 setDate(e.target.value);
// //               }
// //             }}
// //           />
// //         </div>

// //         <div style={{ display: "flex", alignItems: "flex-end" }}>
// //           <Button
// //             disable={vehicle_tracking_loading}
// //             title={"GENERATE"}
// //             onClick={handleGenerate}
// //           />
// //         </div>
// //       </div>

// //       {vehicle_tracking_loading ? (
// //         <PageLoading />
// //       ) : (
// //         <div style={{ marginTop: "20px" }}>
// //           <Table
// //             headData={[
// //               "Godown manager NAME",
// //               "VEHICLE NO",
// //               "Driver NAME",
// //               "REF NO",
// //               "CREATED DATE",
// //               "PRODUCT NAME",
// //               "GODOWN NAME",
// //               "MOVEMENT TYPE",
// //               "FULLS IN",
// //               "EMPTYS IN",
// //               "FULLS OUT",
// //               "EMPTYS OUT",
// //             ]}
// //             body={flatData?.map((row, index) => (
// //               <tr key={index}>
// //                 {row.isFirstRow ? (
// //                   <>
// //                     <td rowSpan={row.detailsCount}>{row.EMPLOYEE_NAME}</td>
// //                     <td rowSpan={row.detailsCount}>{row.VEHICLE_NO}</td>
// //                     <td rowSpan={row.detailsCount}>{row.STAFF_NAME}</td>
// //                     <td rowSpan={row.detailsCount}>{row.REF_NO}</td>
// //                     <td rowSpan={row.detailsCount}>
// //                       {moment(row.CREATED_DATE).format("DD/MM/YYYY hh:mm A")}
// //                     </td>
// //                   </>
// //                 ) : null}
// //                 <td>{row.PRODUCT_NAME}</td>
// //                 <td>{row.GODOWN_NAME}</td>
// //                 <td>
// //                   <span
// //                     style={{
// //                       padding: "4px 12px",
// //                       borderRadius: "6px",
// //                       backgroundColor:
// //                         row.MOVEMENT_TYPE === "IN" ? "#d4edda" : "#f8d7da",
// //                       color: row.MOVEMENT_TYPE === "IN" ? "#155724" : "#721c24",
// //                       fontWeight: "600",
// //                       fontSize: "12px",
// //                     }}
// //                   >
// //                     {row.MOVEMENT_TYPE}
// //                   </span>
// //                 </td>
// //                 <td>{row.FULLS_IN || 0}</td>
// //                 <td>{row.EMPTYS_IN || 0}</td>
// //                 <td>{row.FULLS_OUT || 0}</td>
// //                 <td>{row.EMPTYS_OUT || 0}</td>
// //               </tr>
// //             ))}
// //           />

// //           {flatData?.length === 0 && (
// //             <div
// //               style={{
// //                 textAlign: "center",
// //                 padding: "40px",
// //                 color: "#888",
// //                 fontSize: "16px",
// //               }}
// //             >
// //               No tracking data available for the selected date
// //             </div>
// //           )}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default VehicleTracking;
// // // import React, { useEffect, useState } from "react";
// // // import PageHeading from "../../components/PageHeading";
// // // import { BackButton } from "../../components/btn/Buttons";
// // // import Button from "../../components/btn/Button";
// // // import Input from "../../components/inputs/Input";
// // // import "./DayEnd.css";
// // // import { useSelector } from "react-redux";
// // // import moment from "moment";
// // // import store from "../../redux/store";
// // // import { get_vehicle_tracking } from "./DayendDaySlice";
// // // import PageLoading from "../../components/PageLoading";
// // // import { toast } from "react-toastify";
// // // import Table from "../../components/table/Table";
// // // import RowTxt from "../../components/RowTxt";
// // // import { HiOutlineArrowRight } from "react-icons/hi";
// // // import { motion } from "framer-motion";
// // // import Modal from "../../components/modal/Modal";
// // // import { Pagination3 } from "../../components/pagination/pagination";

// // // const VehicleTracking = () => {
// // //   const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
// // //   const [openView, setOpenView] = useState(false);
// // //   const [viewItem, setViewItem] = useState({});
// // //   const { vehicle_tracking_list, vehicle_tracking_loading } = useSelector(
// // //     (state) => state.day_end
// // //   );

// // //   useEffect(() => {
// // //     loadData();
// // //   }, []);

// // //   const loadData = () => {
// // //     store.dispatch(get_vehicle_tracking({ date: date, page: 1, limit: 100 }));
// // //   };

// // //   const handleGenerate = () => {
// // //     if (!date) {
// // //       toast.error("Please select a date");
// // //       return;
// // //     }
// // //     loadData();
// // //   };

// // //   return (
// // //     <div className="container">
// // //       <PageHeading
// // //         title={"Vehicle Tracking"}
// // //         right={
// // //           <>
// // //             <BackButton />
// // //           </>
// // //         }
// // //       />
// // //       <div className="transactionMain">
// // //         <div style={{ width: "180px" }}>
// // //           <Input
// // //             label={"Select Date"}
// // //             type={"date"}
// // //             value={date}
// // //             onChange={(e) => {
// // //               if (e.target.value.length <= 10) {
// // //                 setDate(e.target.value);
// // //               }
// // //             }}
// // //           />
// // //         </div>

// // //         <div style={{ display: "flex", alignItems: "flex-end" }}>
// // //           <Button
// // //             disable={vehicle_tracking_loading}
// // //             title={"GENERATE"}
// // //             onClick={handleGenerate}
// // //           />
// // //         </div>
// // //       </div>

// // //       {/* <Pagination3
// // //         top={true}
// // //         totalCount={totalCount > SearchCount ? SearchCount : totalCount}
// // //         SerchInput={SerchInput}
// // //         serchChange={(e) => {
// // //           setSearchInput(e.target.value);
// // //           setPrevSearch(SerchInput);
// // //           setPageNo(1);
// // //         }}
// // //         pageNo={pageNo}
// // //         setPageNo={setPageNo}
// // //         entries={entries}
// // //         setEntries={setEntries}
// // //       ></Pagination3> */}
// // //       {vehicle_tracking_loading ? (
// // //         <PageLoading />
// // //       ) : (
// // //         <div className="grid">
// // //           {vehicle_tracking_list?.map((v, i) => (
// // //             <div className="card" key={i}>
// // //               <div className="card-heading">{v?.CREATED_NAME} </div>
// // //               <RowTxt title={"Vehicle Number"} value={v?.VEHICLE_NO} />
// // //               <RowTxt title={"Staff Name"} value={v?.STAFF_NAME} />
// // //               <RowTxt title={"REF No"} value={v?.REF_NO} />
// // //               <RowTxt
// // //                 title={"Created Date"}
// // //                 value={moment(v?.CREATED_DATE).format("DD/MM/YYYY")}
// // //               />
// // //               <div
// // //                 className="df jcsb mt10"
// // //                 style={{
// // //                   justifyContent: "flex-end",
// // //                 }}
// // //               >
// // //                 <div></div>

// // //                 <motion.div
// // //                   whileHover={{ scale: 1.02 }}
// // //                   onClick={() => {
// // //                     setViewItem(v);
// // //                     setOpenView(true);
// // //                   }}
// // //                   whileTap={{ scale: 1.05 }}
// // //                   className="flex aic gap10 jce cursor-pointer"
// // //                 >
// // //                   <div className="view-btn">View</div>
// // //                   <HiOutlineArrowRight size={20} color="#1b64af" />
// // //                 </motion.div>
// // //               </div>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       )}
// // //       {openView && (
// // //         <Modal
// // //           isOpen={openView}
// // //           title={"Vehicle Details"}
// // //           onCancel={() => {
// // //             setViewItem({});
// // //           }}
// // //           setIsOpen={setOpenView}
// // //           body={
// // //             <>
// // //               <div className="card-heading">{viewItem?.CREATED_NAME} </div>
// // //               <RowTxt title={"Vehicle Number"} value={viewItem?.VEHICLE_NO} />
// // //               <RowTxt title={"Staff Name"} value={viewItem?.STAFF_NAME} />
// // //               <RowTxt title={"REF No"} value={viewItem?.REF_NO} />
// // //               <RowTxt
// // //                 title={"Created Date"}
// // //                 value={moment(viewItem?.CREATED_DATE).format("DD/MM/YYYY")}
// // //               />

// // //               <Table
// // //                 mt={10}
// // //                 headData={[
// // //                   "PRODUCT NAME",
// // //                   "GODOWN NAME",
// // //                   "MOVEMENT TYPE",
// // //                   "FULLS IN",
// // //                   "EMPTYS IN",
// // //                   "FULLS OUT",
// // //                   "EMPTYS OUT",
// // //                   // ...(val?.MOVEMENT_TYPE === "OUT"
// // //                   //   ? ["FULLS OUT", "EMPTYS OUT"]
// // //                   //   : ["FULLS IN", "EMPTYS IN"]),
// // //                 ]}
// // //                 body={viewItem?.details?.map((val, ind) => (
// // //                   <tr>
// // //                     <td>{val?.PRODUCT_NAME}</td>
// // //                     <td>{val?.GODOWN_NAME}</td>
// // //                     <td>{val?.MOVEMENT_TYPE}</td>
// // //                     {/* {val?.MOVEMENT_TYPE === "OUT" ? (
// // //                       <> */}
// // //                     <td>{val?.FULLS_IN}</td>
// // //                     <td>{val?.EMPTYS_IN}</td>
// // //                     <td>{val?.FULLS_OUT}</td>
// // //                     <td>{val?.EMPTYS_OUT}</td>
// // //                     {/* </>
// // //                     ) : (
// // //                       <> */}
// // //                     {/* </>
// // //                     )} */}
// // //                   </tr>
// // //                 ))}
// // //               />
// // //             </>
// // //           }
// // //         ></Modal>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default VehicleTracking;
// // // // import React, { useEffect, useState } from "react";
// // // // import PageHeading from "../../components/PageHeading";
// // // // import { BackButton, HelpButton } from "../../components/btn/Buttons";
// // // // import Button from "../../components/btn/Button";
// // // // import Input from "../../components/inputs/Input";
// // // // import "./DayEnd.css";
// // // // import Table from "../../components/table/Table";
// // // // import { useSelector } from "react-redux";
// // // // import moment from "moment";
// // // // import { dayendHeaders } from "../../utils/data";
// // // // import store from "../../redux/store";
// // // // import { get_day_end_day_list, get_vehicle_tracking } from "./DayendDaySlice";
// // // // import PageLoading from "../../components/PageLoading";

// // // // import { Switch } from "antd";
// // // // import { toast } from "react-toastify";
// // // // import { day_end_date_api } from "../../utils/apis";
// // // // import Loader from "../../components/Loader";
// // // // import RadioBtn from "../../components/radio/RadioBtn";
// // // // import { CheckBox } from "../../components/inputs/CheckBox";

// // // // const VehicleTracking = () => {
// // // //   const [verified, setVerified] = useState(true);
// // // //   const [date, setDate] = useState("");
// // // //   const [dateData, setDateData] = useState({});
// // // //   const [show, setShow] = useState(false);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const { day_end_date } = useSelector((state) => state.profile);
// // // //   const [selectLink, setSelectLink] = useState([]);
// // // //   const [addDataHead, setAddDataHead] = useState([]);

// // // //   const { user_id } = useSelector((state) => state.other);
// // // //   const { vehicle_tracking_list, vehicle_tracking_loading } = useSelector(
// // // //     (state) => state.day_end
// // // //   );
// // // //   console.log("vehicle_tracking_list", vehicle_tracking_list);

// // // //   useState(() => {
// // // //     setDateData({
// // // //       date: moment(day_end_date).format("YYYY-MM-DD"),
// // // //       fd: "",
// // // //       td: "",
// // // //     });
// // // //   }, [day_end_date]);

// // // //   const handle_update = async (type) => {
// // // //     try {
// // // //       setLoading(true);
// // // //       const body = new FormData();
// // // //       body.append("action", "updatedayendlist");
// // // //       body.append("agencyid", user_id);
// // // //       body.append("date", dateData?.date);
// // // //       body.append("type", type);

// // // //       addDataHead
// // // //         ?.filter((v, i) => v.flag == type)
// // // //         .forEach((val, ind) => {
// // // //           body.append("id[]", val?.id);
// // // //           body.append("status[]", val?.status);
// // // //           if (val?.st_flag) {
// // // //             body.append("STOCK_FLAG[]", val?.st_flag);
// // // //           } else if (val?.bt_flag) {
// // // //             body.append("BTFLAG[]", val?.bt_flag);
// // // //           }
// // // //         });
// // // //       const res = await day_end_date_api(body);
// // // //       if (res.success) {
// // // //         toast.success(res.message);
// // // //         const filterData = addDataHead?.filter((v, i) => v.flag != type);
// // // //         setAddDataHead(filterData);
// // // //         store.dispatch(
// // // //           get_day_end_day_list({
// // // //             ...dateData,
// // // //             verified,
// // // //             selectLink: selectLink,
// // // //           })
// // // //         );
// // // //       } else {
// // // //         toast.error(res.message);
// // // //       }
// // // //     } catch (error) {
// // // //       console.log("error :", error);
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   // Columns that should be merged vertically across ALL rows
// // // //   const MERGE_COLUMNS = [
// // // //     "VEHICLE_NO",
// // // //     "PRODUCT_NAME",
// // // //     "MOVEMENT_TYPE",
// // // //     "GODOWN_NAME",
// // // //   ];
// // // //   useEffect(() => {
// // // //     store.dispatch(
// // // //       get_vehicle_tracking({ date: "2025-12-26", page: 1, limit: 10 })
// // // //     );
// // // //   }, []);

// // // //   return (
// // // //     <div className="container">
// // // //       <PageHeading
// // // //         title={"Transaction Verification"}
// // // //         right={
// // // //           <>
// // // //             <BackButton />
// // // //           </>
// // // //         }
// // // //       />

// // // //       <div
// // // //         style={{
// // // //           display: "flex",
// // // //           alignItems: "flex-end",
// // // //           gap: "20px",
// // // //           marginTop: "1rem",
// // // //           alignItems: "center",
// // // //         }}
// // // //       >
// // // //         <Button
// // // //           disable={loading || vehicle_tracking_loading}
// // // //           title={"GENERATE"}
// // // //           onClick={async () => {
// // // //             setLoading(true);

// // // //             setLoading(false);
// // // //           }}
// // // //         />
// // // //       </div>
// // // //       {vehicle_tracking_loading || loading ? (
// // // //         <PageLoading />
// // // //       ) : (
// // // //         <div>
// // // //           {dayendHeaders?.map((v, i) => (
// // // //             <div className="mt10" key={i}>
// // // //               {vehicle_tracking_list?.[v?.id]?.length > 0 && (
// // // //                 <>
// // // //                   <p className="DayEndText mt10">
// // // //                     {v?.id?.split("_").join(" ").toUpperCase()} DETAILS
// // // //                   </p>

// // // //                   <Table
// // // //                     mt={5}
// // // //                     headData={MERGE_COLUMNS}
// // // //                     body={vehicle_tracking_list?.[v?.id].map(
// // // //                       (val, ind, arr) => {
// // // //                         return <tr key={ind}></tr>;
// // // //                       }
// // // //                     )}
// // // //                   />
// // // //                 </>
// // // //               )}
// // // //             </div>
// // // //           ))}
// // // //         </div>
// // // //       )}
// // // //       {loading && !show && <Loader loading={loading && !show} />}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default VehicleTracking;
